import Link from "next/link";
import Image from "next/image";
import logoWhite from "../../../assets/logo podcast white.png";
import logoColor from "../../../assets/logo podcast color .png";
import closeIcon from "@/assets/close-icon.svg";
import { useState } from "react";
import { FaAngleDoubleLeft, FaRegUserCircle } from "react-icons/fa";
import { useMyInfoQuery } from "@/Redux/features/UserProfileInfo/UserProfileInfoApi";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@/Redux/features/auth/authSlice";
import { useLogOutMutation } from "@/Redux/features/auth/authApi";
import Loading from "../loading";
import { clearAudio } from "@/Redux/features/audioPlayer/audioPlayerSlice";

export default function MobileNav({ setOpen }) {
  const [subNavDrawer, setSubNavDrawer] = useState(false);

  const {
    data: profileInfo,
    isLoading: myInfoLoading,
    isrefetch: profileInfoRefetch,
  } = useMyInfoQuery();

  // const [userLogout] = useLogOutMutation();
  const dispatch = useDispatch();
  const handleLogOut = () => {
    dispatch(logout());
    dispatch(clearAudio());
  };

  const picURL = profileInfo?.user?.picture?.path;
  const userName = `${profileInfo?.user?.firstName} ${profileInfo?.user?.lastName}`;

  const navigation = [
    { label: "HOME", url: "/" },
    { label: "SHOWS", url: "/podcast" },
    { label: "EPISODES", url: "/episodes" },
    // { label: 'BLOGS', url: '/blogs' },
    // { label: "BECOME AN AUTHOR", url: "/profile" },
    { label: "PROFILE", url: "/profile" },
    { label: "SETTING", url: "/profile-setting" },
  ];

  return (
    <aside className="fixed top-0 left-0 w-[300px] h-full dark:bg-gray-800 bg-blue-100 z-[100]">
      {myInfoLoading || (profileInfoRefetch && <Loading />)}

      <nav className="px-[1.25rem]">
        <div className="flex items-center justify-between py-[1.5rem]">
          <Link href="/">
            <Image className={`w-48 dark:hidden`} src={logoColor} alt="Logo" />
            <Image
              className={`w-48 hidden dark:block`}
              src={logoWhite}
              alt="Logo"
            />
          </Link>
          <button onClick={() => setOpen(false)}>
            <FaAngleDoubleLeft className="text-2xl text-blue-600 dark:text-white" />
          </button>
        </div>

        {profileInfo && (
          <div className="flex flex-col items-center justify-center my-5">
            {picURL ? (
              <div>
                <div
                  // onClick={() => setProfileDrawer(!profileDrawer)}
                  className="ml-1/2 cursor-pointer rounded-full w-12 h-12 md:bg-gradient-to-l  from-blue-500 to-[#3ae9da]"
                >
                  <Image
                    className="border-2 md:border-none border-blue-600  md:p-1 mx-auto w-12 h-12 rounded-full"
                    src={`${
                      profileInfo?.user?.picture?.path
                        ? profileInfo?.user?.picture?.path
                        : "/"
                    }`}
                    alt="logo"
                    priority
                    width={400}
                    height={300}
                  />
                </div>
              </div>
            ) : (
              <>
                <FaRegUserCircle
                  onClick={() => setProfileDrawer(!profileDrawer)}
                  className="hidden lg:block text-4xl text-blue-600 cursor-pointer"
                />
              </>
            )}

            <p className="my-2 font-semibold">{userName}</p>
          </div>
        )}

        <ul className="flex flex-col gap-[12px] ">
          {profileInfo &&
            navigation?.map((item) => (
              <li key={item.label} className="dark:text-white relative group">
                {item?.label === "Services" ? (
                  <p onClick={() => setSubNavDrawer(true)}>{item.label}</p>
                ) : (
                  <Link href={item?.url}>{item.label}</Link>
                )}

                {item?.subNav && (
                  <ul
                    className={`z-50 p-5 absolute space-y-2 rounded bg-blue-800 text-white  border border-gray-200 left-0 top-full ${
                      subNavDrawer === true ? "block" : "hidden"
                    }`}
                  >
                    {item.subNav.map((subNavItem) => (
                      <li
                        className="hover:font-semibold"
                        key={subNavItem.label}
                      >
                        <Link href={subNavItem.url}>{subNavItem.label}</Link>
                      </li>
                    ))}

                    <li
                      onClick={() => setSubNavDrawer(false)}
                      className="flex justify-end text-red-500 font-blod"
                    >
                      Close
                    </li>
                  </ul>
                )}
              </li>
            ))}
          {/* 
          <li className="dark:text-white">
            <Link href="/contact-us">CONTACT</Link>
          </li> */}

          {profileInfo ? (
            <li className="dark:text-white">
              <Link
                onClick={() => handleLogOut()}
                className="text-red-600 font-semibold"
                href="/"
              >
                LOGOUT
              </Link>
            </li>
          ) : (
            <li className="dark:text-white font-semibold flex flex-col gap-5">
              <Link href="/login">LOGIN</Link>
              <Link href="/sign-up">SIGNUP</Link>
            </li>
          )}
        </ul>
      </nav>
    </aside>
  );
}
